export default __webpack_public_path__ + "static/media/modal-delete-note.ac7ab735.png";